/* RenzoBoggio Estudio — JS mínimo sin dependencias.
   Carrito lateral, búsqueda predictiva, variantes, barra de compra móvil y eventos de analítica. */
(() => {
  const RB = window.RB || {};
  const $ = (s, r = document) => r.querySelector(s);
  const $$ = (s, r = document) => Array.from(r.querySelectorAll(s));

  /* ---------- Formato de dinero ---------- */
  const money = (cents) => {
    const fmt = RB.moneyFormat || 'S/. {{amount}}';
    const amount = (cents / 100).toFixed(2);
    const withSep = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','))
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100))
      .replace(/\{\{\s*amount\s*\}\}/, withSep);
  };
  const esc = (s) => String(s ?? '').replace(/[&<>"']/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]));

  /* ---------- Analítica: eventos personalizados (los recoge el píxel personalizado) ---------- */
  const track = (name, data = {}) => {
    try { window.Shopify?.analytics?.publish?.(name, data); } catch (e) { /* sin analítica en vista previa */ }
  };
  document.addEventListener('click', (e) => {
    const el = e.target.closest('[data-rb-event]');
    if (el) track(el.dataset.rbEvent, { label: el.dataset.rbLabel || '', url: el.href || '' });
  });
  $$('form[data-rb-form]').forEach((f) => f.addEventListener('submit', () => track('rb_form_submit', { form: f.dataset.rbForm })));
  if (document.querySelector('[data-rb-form-success]')) track('rb_form_success', { form: document.querySelector('[data-rb-form-success]').dataset.rbFormSuccess });

  /* ---------- Diálogos ---------- */
  let lastTrigger = null;
  const openDialog = (id) => {
    const d = document.getElementById(id);
    if (!d || d.open) return;
    lastTrigger = document.activeElement;
    d.showModal();
    if (id === 'search-drawer') setTimeout(() => $('[data-predictive-input]')?.focus(), 30);
    if (id === 'cart-drawer') renderCart();
  };
  document.addEventListener('click', (e) => {
    const opener = e.target.closest('[data-open]');
    if (opener) { e.preventDefault(); openDialog(opener.dataset.open); return; }
    const closer = e.target.closest('[data-close]');
    if (closer) { closer.closest('dialog')?.close(); return; }
    if (e.target.tagName === 'DIALOG') e.target.close(); // clic en el fondo
  });
  $$('dialog').forEach((d) => d.addEventListener('close', () => lastTrigger?.focus?.()));

  /* ---------- Carrito ---------- */
  const setCount = (n) => $$('[data-cart-count]').forEach((el) => { el.textContent = n; el.hidden = n === 0; });
  const freebar = (total) => {
    const box = $('[data-freebar]');
    if (!box) return;
    const fs = RB.freeShipping || {};
    if (!fs.enabled || fs.country !== 'PE' || !total) { box.innerHTML = ''; return; }
    const left = fs.threshold - total;
    const pct = Math.min(100, Math.round((total / fs.threshold) * 100));
    box.innerHTML = `<div class="freebar">${left > 0 ? esc(RB.t.free_left).replace('[amount]', money(left)) : esc(RB.t.free_ok)}<div class="freebar__track"><div class="freebar__fill" style="width:${pct}%"></div></div></div>`;
  };
  const renderCart = async () => {
    const wrap = $('[data-cart-items]');
    if (!wrap) return;
    const cart = await fetch(`${RB.routes.cart}.js`).then((r) => r.json());
    setCount(cart.item_count);
    $('[data-cart-subtotal]').textContent = money(cart.total_price);
    $('[data-cart-checkout]').disabled = cart.item_count === 0;
    freebar(cart.total_price);
    if (!cart.items.length) { wrap.innerHTML = `<p>${esc(RB.t.empty)}</p>`; return; }
    wrap.innerHTML = cart.items.map((it, i) => `
      <div class="line-item">
        ${it.image ? `<img src="${esc(it.image.replace(/(\.\w+)(\?|$)/, '_200x$1$2'))}" alt="" width="72" height="88" loading="lazy">` : '<span></span>'}
        <div>
          <a class="line-item__title" href="${esc(it.url)}">${esc(it.product_title)}</a>
          ${it.variant_title ? `<p class="small">${esc(it.variant_title)}</p>` : ''}
          <div class="qty" style="margin-top:.4rem;">
            <button type="button" data-line="${i + 1}" data-qty="${it.quantity - 1}" aria-label="${esc(RB.t.decrease)}">−</button>
            <input type="number" value="${it.quantity}" min="0" aria-label="${esc(it.product_title)}" readonly>
            <button type="button" data-line="${i + 1}" data-qty="${it.quantity + 1}" aria-label="${esc(RB.t.increase)}">+</button>
          </div>
          <button class="link-btn" type="button" data-line="${i + 1}" data-qty="0">${esc(RB.t.remove)}</button>
        </div>
        <strong class="small">${money(it.final_line_price)}</strong>
      </div>`).join('');
  };
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-line]');
    if (!b) return;
    await fetch(`${RB.routes.cart_change}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ line: Number(b.dataset.line), quantity: Number(b.dataset.qty) }) });
    renderCart();
  });

  /* Agregar al carrito sin recargar (con respaldo nativo si falla JS) */
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('submit', async (e) => {
      e.preventDefault();
      const btn = form.querySelector('[type="submit"]');
      btn.disabled = true;
      try {
        const res = await fetch(`${RB.routes.cart_add}.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
        if (!res.ok) throw new Error((await res.json()).description || RB.t.error);
        $('[data-cart-status]').textContent = RB.t.added;
        openDialog('cart-drawer');
      } catch (err) {
        alert(err.message || RB.t.error);
      } finally {
        btn.disabled = false;
        updateVariant(form);
      }
    });
  });

  /* ---------- Variantes ---------- */
  function updateVariant(form) {
    const dataEl = form.querySelector('[data-variants]');
    if (!dataEl) return;
    const variants = JSON.parse(dataEl.textContent);
    const chosen = $$('[data-option-index]', form).filter((i) => i.checked).map((i) => i.value);
    const v = variants.find((x) => x.options.every((o, idx) => o === chosen[idx])) || null;
    const idInput = form.querySelector('[name="id"]');
    const btns = $$('[data-add-button]');
    const waSoldOut = $('[data-soldout-wa]');
    if (v) idInput.value = v.id;
    btns.forEach((btn) => {
      // La barra fija ofrece WhatsApp cuando la variante está agotada (S17)
      if (btn.matches('[data-sticky-add]') && v && !v.available && waSoldOut) {
        btn.disabled = false;
        btn.textContent = RB.t.notify || RB.t.sold_out;
        return;
      }
      btn.disabled = !v || !v.available;
      btn.textContent = !v ? RB.t.unavailable : v.available ? RB.t.add : RB.t.sold_out;
    });
    if (waSoldOut) waSoldOut.hidden = !v || v.available;
    // Etiquetas de opción seleccionada
    $$('[data-option-index]', form).filter((i) => i.checked).forEach((i) => {
      const label = form.querySelector(`[data-option-label="${i.dataset.optionIndex}"]`);
      if (label) label.textContent = i.value;
    });
    if (v) {
      const tpl = $(`template[data-price-for="${v.id}"]`);
      if (tpl) $$('[data-variant-price]').forEach((p) => { p.innerHTML = tpl.innerHTML; });
      const sp = $('[data-sticky-price]');
      if (sp && v.price) sp.textContent = v.price;
      const sv = $('[data-sticky-variant]');
      if (sv && v.title && v.title !== 'Default Title') sv.textContent = `${v.title} · `;
      const note = $('[data-stock-note]');
      if (note) { note.hidden = !v.low; note.textContent = v.low === 1 ? RB.t.low_one : v.low === 2 ? RB.t.low_two : ''; }
      const wa = $('[data-wa-ask]');
      if (wa) {
        const name = v.title && v.title !== 'Default Title' ? `${wa.dataset.waProduct} — ${v.title}` : wa.dataset.waProduct;
        wa.href = wa.dataset.waBase + encodeURIComponent(RB.t.wa_prefill.replace('[product]', name).replace('[url]', `${wa.dataset.waUrl}?variant=${v.id}`));
      }
      if (v.featured_media_id) showMedia(String(v.featured_media_id));
      const url = new URL(window.location.href);
      url.searchParams.set('variant', v.id);
      history.replaceState(null, '', url);
    }
  }
  $$('form[data-product-form]').forEach((form) => {
    form.addEventListener('change', (e) => { if (e.target.matches('[data-option-index]')) updateVariant(form); });
  });

  /* Galería (S2): carrusel con flechas y miniaturas; en escritorio queda fija a la izquierda */
  const gTrack = $('[data-gallery-track]');
  const gSlides = gTrack ? $$('.gallery__slide', gTrack) : [];
  const gIndex = () => (gTrack ? Math.round(gTrack.scrollLeft / Math.max(1, gTrack.clientWidth)) : 0);
  const goTo = (i) => {
    if (!gTrack || !gSlides.length) return;
    const n = Math.max(0, Math.min(gSlides.length - 1, i));
    gTrack.scrollTo({ left: n * gTrack.clientWidth, behavior: 'smooth' });
  };
  function showMedia(id) {
    const i = gSlides.findIndex((s) => s.dataset.mediaId === String(id));
    if (i >= 0) goTo(i);
  }
  const counter = $('[data-gallery-counter]');
  const syncGallery = () => {
    const i = gIndex();
    if (counter) counter.textContent = RB.t.gallery_counter.replace('[current]', Math.min(i + 1, gSlides.length)).replace('[total]', gSlides.length);
    $$('[data-thumb]').forEach((t) => t.setAttribute('aria-current', String(t.dataset.thumb === gSlides[i]?.dataset.mediaId)));
  };
  gTrack?.addEventListener('scroll', syncGallery, { passive: true });
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-gallery-step]');
    if (step) { goTo(gIndex() + Number(step.dataset.galleryStep)); return; }
    const thumb = e.target.closest('[data-thumb]');
    if (thumb) showMedia(thumb.dataset.thumb);
  });
  gTrack?.addEventListener('keydown', (e) => {
    if (e.key === 'ArrowRight') { e.preventDefault(); goTo(gIndex() + 1); }
    if (e.key === 'ArrowLeft') { e.preventDefault(); goTo(gIndex() - 1); }
  });
  // Si se llega con ?variant=, mostrar su foto
  try {
    const vid = new URL(location.href).searchParams.get('variant');
    const data = $('[data-variants]');
    if (vid && data) {
      const v = JSON.parse(data.textContent).find((x) => String(x.id) === vid);
      if (v?.featured_media_id) requestAnimationFrame(() => { const i = gSlides.findIndex((s) => s.dataset.mediaId === String(v.featured_media_id)); if (i > 0 && gTrack) { gTrack.scrollLeft = i * gTrack.clientWidth; syncGallery(); } });
    }
  } catch (e) { /* sin variante en la URL */ }
  document.addEventListener('click', (e) => {
    const z = e.target.closest('[data-zoom]');
    if (!z) return;
    const img = $('[data-zoom-img]');
    if (!img) return;
    img.src = z.dataset.zoom;
    img.alt = z.querySelector('img')?.alt || '';
    openDialog('gallery-zoom');
  });

  /* Completa el set: agregado rápido (S13) */
  document.addEventListener('click', async (e) => {
    const b = e.target.closest('[data-quick-add]');
    if (!b) return;
    b.disabled = true;
    try {
      const res = await fetch(`${RB.routes.cart_add}.js`, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(b.dataset.quickAdd), quantity: 1 }] }) });
      if (!res.ok) throw new Error((await res.json()).description || RB.t.error);
      $('[data-cart-status]').textContent = RB.t.added;
      openDialog('cart-drawer');
    } catch (err) {
      alert(err.message || RB.t.error);
    } finally {
      b.disabled = false;
    }
  });

  /* Cantidad */
  document.addEventListener('click', (e) => {
    const step = e.target.closest('[data-step]');
    if (!step) return;
    const input = step.parentElement.querySelector('input');
    input.value = Math.max(1, Number(input.value || 1) + Number(step.dataset.step));
  });

  /* Barra de compra fija en móvil */
  const buy = $('[data-buy-anchor]');
  const sticky = $('[data-sticky-buy]');
  if (buy && sticky && 'IntersectionObserver' in window) {
    document.body.classList.add('has-sticky-buy');
    let pastBuy = false;
    let footerVisible = false;
    const setSticky = () => {
      const show = pastBuy && !footerVisible && !document.activeElement?.matches?.('input, textarea, select');
      sticky.classList.toggle('is-visible', show);
      sticky.setAttribute('aria-hidden', String(!show));
      sticky.inert = !show;
      document.body.classList.toggle('sticky-on', show);
    };
    new IntersectionObserver(([entry]) => { pastBuy = !entry.isIntersecting && entry.boundingClientRect.top < 0; setSticky(); }).observe(buy);
    const footer = $('footer, .site-footer');
    if (footer) new IntersectionObserver(([entry]) => { footerVisible = entry.isIntersecting; setSticky(); }).observe(footer);
    document.addEventListener('focusin', setSticky);
    document.addEventListener('focusout', () => setTimeout(setSticky, 0));
    sticky.querySelector('[data-sticky-add]')?.addEventListener('click', () => {
      const wa = $('[data-soldout-wa]');
      if (wa && !wa.hidden) { window.open(wa.href, '_blank', 'noopener'); return; }
      $('form[data-product-form] [type="submit"]')?.click();
    });
  }

  /* ---------- Búsqueda predictiva ---------- */
  const qInput = $('[data-predictive-input]');
  const qOut = $('[data-predictive-results]');
  let ctrl;
  qInput?.addEventListener('input', () => {
    const q = qInput.value.trim();
    ctrl?.abort();
    if (q.length < 2) { qOut.innerHTML = ''; return; }
    ctrl = new AbortController();
    fetch(`${RB.routes.predictive}.json?q=${encodeURIComponent(q)}&resources[type]=product,page&resources[limit]=6`, { signal: ctrl.signal })
      .then((r) => r.json())
      .then(({ resources }) => {
        const prods = (resources.results.products || []).filter((p) => !(RB.hidden || []).includes(p.handle));
        const pages = resources.results.pages || [];
        if (!prods.length && !pages.length) { qOut.innerHTML = `<p>${esc(RB.t.no_results)}</p>`; return; }
        qOut.innerHTML = `<ul>${prods.map((p) => `<li><a href="${esc(p.url)}">${p.image ? `<img src="${esc(p.image)}" alt="" width="56" height="68" loading="lazy">` : '<span></span>'}<span><strong>${esc(p.title)}</strong><br><span class="small">${esc(p.price ? money(Math.round(Number(p.price) * 100)) : '')}</span></span></a></li>`).join('')}${pages.map((p) => `<li><a href="${esc(p.url)}"><span></span><span><strong>${esc(p.title)}</strong></span></a></li>`).join('')}</ul>`;
      })
      .catch(() => {});
  });

  /* ---------- Selector de país/idioma ---------- */
  $$('[data-autosubmit]').forEach((s) => s.addEventListener('change', () => s.form.submit()));

  /* Contador inicial del carrito */
  if (document.readyState !== 'loading') freebarInit(); else document.addEventListener('DOMContentLoaded', freebarInit);
  function freebarInit() { fetch(`${RB.routes.cart}.js`).then((r) => r.json()).then((c) => { setCount(c.item_count); freebar(c.total_price); }).catch(() => {}); }
})();
